module.exports = __webpack_public_path__ + "img/168.a417cf24.jpg";